// extracted by mini-css-extract-plugin
export default {"main_div":"FormModal_main_div__zadFC","error_msg":"FormModal_error_msg__TjaL7","form_div":"FormModal_form_div__LCjue"};